export default __webpack_public_path__ + "static/InterDisplay-Light-9981951c88b7af0bd128ad9403a0ebbb.woff2";